<template>
  <!-- ホルター解析依頼 -->
  <div id="HolterAnalysisOrder">
    <div id="container">
      <holterNavi v-bind:pageid='"HolterAnalysisOrder"'></holterNavi>
      <div class="labelTitle lable">ホルター心電図配送ｻｰﾋﾞｽ 解析依頼一覧</div>
      <!--検索条件 -->
      <div class="condition-area">
        <table class="conditionTable">
          <tr>
            <th>受付番号</th>
            <td><input type="text" v-model="searchConditions.receiptNumber"/></td>
            <th>デモ</th>
            <td><select v-model="searchConditions.demo">
                <option></option>
                <option value="false">含まない</option>
                <option value="true">デモのみ</option>
              </select></td>
            <th>機種</th>
            <td><select v-model="searchConditions.instrumentKind">
                <option v-for="model in modelList" :value="model.value" :key="model.value">{{ model.label1 }}</option>
              </select></td>
            <th>依頼元</th>
            <td><input type="text" v-model="searchConditions.client"/></td>
          </tr>
          <tr>
            <th>患者名</th>
            <td><input type="text" v-model="searchConditions.patientName"/></td>
            <th>状態</th>
            <td><select v-model="searchConditions.status">
                <option v-for="status in statusList" :key="status.code" :value="status.code">{{status.name}}</option>
              </select></td>
            <th>シリアル</th>
            <td><input id="serialInput" type="text" v-model="searchConditions.serial" @keyup.enter="onKeyupEnter()"/></td>
          </tr>
        </table>
        <div class="searchButton-area">
          <b-button
            class="is-primary"
            @click="doSearch"
          >検索</b-button>
        </div>
      </div>
      <!-- 検索結果 -->
      <div
        class="result-area"
        v-if="hasResult"
      >
        <b-table
          id="holterAnalysisOrderTable"
          :data="data"
          :paginated="isPaginated"
          per-page="100"
          pagination-position="both"
          default-sort="user.first_name"
          aria-next-label="Next page"
          aria-previous-label="Previous page"
          aria-page-label="Page"
          aria-current-label="Current page"
        >
          <template slot-scope="props">
            <b-table-column field="receiptNumber" label="受付番号" width="110" sortable centered>
              <router-link :to="{name:'HolterAnalysisOrderDetail',params:{receiptNumber:props.row.receiptNumber, status:props.row.status, searchConditions:searchConditions}}"><a>{{props.row.receiptNumber}}</a></router-link>
            </b-table-column>
            <b-table-column field="requestDate" label="受付日" width="130" sortable centered>{{props.row.requestDate }}</b-table-column>
            <b-table-column field="kind" label="種別" width="120" sortable>{{props.row.kind}}
              <span v-if="props.row.depositMachineFlag" class="depo"/>
            </b-table-column>
            <b-table-column field="instrumentKind" label="機種" width="190" sortable>{{props.row.instrumentKind}}</b-table-column>
            <b-table-column field="serial" label="シリアル" width="120" sortable>{{props.row.serial}}</b-table-column>
            <b-table-column field="client" label="依頼元">{{props.row.client}}</b-table-column>
            <b-table-column field="patientName" label="患者名">{{props.row.patientName}}</b-table-column>
            <b-table-column field="status" label="状態" width="80" centered>
              <span :class="getHstAnalysisTagClass(props.row.status)">
                {{getAnalysis(props.row.status)}}
              </span>
            </b-table-column>
          </template>
        </b-table>
      </div>
    </div>
  </div>
</template>

<script>
import naviBar from "@/components/mock/philips/holter/HolterNaviBar";
import {choicesType} from "@/components/mock/base/const.js";

export default {
  name: "HolterAnalysisOrder",
  methods: {
    onKeyupEnter: function(){
      //シリアルを取得
      let serialItems = this.searchConditions.serial.split('/');
      if(serialItems.length == 2){
        //　"/"が含まれていたらそれ以降の文字に変更する
        this.searchConditions.serial = serialItems[1]
      }
    },
    doSearch: function() {
      var isSearchParam = false
      var keys = Object.keys(this.searchConditions)
      for(var i=0; i < keys.length; i++){
        if(this.searchConditions[keys[i]]){
          isSearchParam = true
          break;
        }
      }
      if(!isSearchParam){
        // 検索条件が１つも設定されていない場合
        this.showErrorMessage("検索条件が入力されていません。")
        return;
      }
      this.data = []
      this.hasResult = false;
      var excuteApi = this.getHolterAnalysisRequestListPOST;
      var successCallBack = this.getHolterAnalysisRequestListPOSTSuccess;
      var errorCallBack = this.getHolterAnalysisRequestListPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getHolterAnalysisRequestListPOST: function(client) {
      var obj = JSON.parse(JSON.stringify(this.searchConditions));
      obj.status = obj.status && obj.status.length!=0 ? JSON.parse(obj.status) : []
      return client.apis.internalHolter.getHolterAnalysisRequestListPOST({
        body:obj
      });
    },
    getHolterAnalysisRequestListPOSTSuccess: function(result) {
      // 検索結果取得
      this.data = result.obj
      if(this.data.length > 0){
        this.hasResult = true;
      }
    },
    getHolterAnalysisRequestListPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
  },
  data() {
    var takeOverSearchParams = this.$route.params["searchConditions"];
    var statusList = this.getAnalysisStatusList()
    statusList.unshift({})
    var modelList = this.getChoiceList(choicesType.holterKind, false);
    modelList.unshift({})
    return {
      searchConditions:{
        receiptNumber:"",
        kind:"",
        instrumentKind:"",
        client:"",
        patientName:"",
        status:"",
        serial:""
      },
      data: [],
      isPaginated: true,
      hasResult: false,
      takeOverSearchParams,
      statusList,
      modelList
    };
  },
  async mounted() {
    if(this.takeOverSearchParams){
      this.searchConditions = this.takeOverSearchParams
      this.doSearch()
    }
  },
  filters: {},
  components: {
    holterNavi: naviBar
  }
};
</script>
<style lang="scss" scoped>
a {
  text-decoration: underline;
}
input {
  width: 200px;
}
.depo::after {
  margin-top: 1px;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/philips/holter/HolterAnalysisOrder.vue